import { useState } from 'react';

import { S3Object } from '../../../drive/types';
import { ensureTrailingSlash, isDirectory } from '../helpers';

export interface UseDirectoryOperationsProps {
  s3Service: {
    objects?: S3Object[];
    createDirectory: (name: string, path: string, refreshPrefix?: string) => Promise<void>;
  };
  currentDirectoryPath: string;
}

export const useDirectoryOperations = ({ s3Service, currentDirectoryPath }: UseDirectoryOperationsProps) => {
  const [directoryModalOpen, setDirectoryModalOpen] = useState(false);

  const handleCreateDirectory = () => {
    setDirectoryModalOpen(true);
  };

  const handleDirectoryModalClose = () => {
    setDirectoryModalOpen(false);
  };

  const handleDirectoryModalConfirm = async (directoryName: string) => {
    try {
      await s3Service?.createDirectory(directoryName, currentDirectoryPath);
      setDirectoryModalOpen(false);
    } catch (error) {
      console.error('Failed to create directory:', error);
    }
  };

  const existingDirectories =
    (s3Service?.objects
      ?.filter((obj) => {
        if (!obj.Key) return false;
        if (!isDirectory(obj.Key)) return false;

        if (!currentDirectoryPath) {
          return !obj.Key.slice(0, -1).includes('/');
        }

        const normalizedCurrentPath = ensureTrailingSlash(currentDirectoryPath);
        if (!obj.Key.startsWith(normalizedCurrentPath)) return false;

        const relativePath = obj.Key.substring(normalizedCurrentPath.length);
        return relativePath && !relativePath.slice(0, -1).includes('/');
      })
      ?.map((obj) => obj.Key!)
      .filter(Boolean) as string[]) || [];

  return {
    directoryModalOpen,
    existingDirectories,
    handleCreateDirectory,
    handleDirectoryModalClose,
    handleDirectoryModalConfirm,
  };
};
